// @flow

const CMS = {
    Home: {
        Entity: 'Home',
        File: 'home.xml',
    },
    FAQs: {
        Entity: 'FAQs',
        File: 'faqs.xml',
    },
    ContactSupport: {
        Entity: 'ContactSupport',
        File: 'contact-support.xml',
    },
    Api: {
        Entity: 'GetStarted',
        File: 'api.xml',
    },
    ApiAuthentication: {
        Entity: 'GetsAuthenticationtart',
        File: 'api-authentication.xml',
    },
    ApiErrorHandling: {
        Entity: 'ErrorHandling',
        File: 'api-errorhandling.xml',
    },
    Changelog: {
        Entity: 'Changelog',
        File: 'changelog.xml',
    },
    ApiProducts: {
        Entity: 'ApiProducts',
        File: 'apiproducts/apiproducts.xml',
    },
    DocsIntoduction: {
        Entity: 'DocsIntoduction',
        File: 'docs/docs-introduction.xml',
    },
    DocsGetToken: {
        Entity: 'CurrentVer-GetToken',
        File: 'docs/docs-gettoken.xml',
        ApiType: 'Authentication',
    },
    DocsTaxSotware: {
        Entity: 'CurrentVer-TaxSoftware',
        File: 'docs/docs-taxsoftware.xml',
        ApiType: 'Lookup Methods',
    },
    DocsBinderTypes: {
        Entity: 'CurrentVer-BinderTypes',
        File: 'docs/docs-bindertypes.xml',
        ApiType: 'Lookup Methods',
    },
    DocsBinderTemplates: {
        Entity: 'CurrentVer-BinderTemplates',
        File: 'docs/docs-bindertemplates.xml',
        ApiType: 'Lookup Methods',
    },
    DocsOfficeLocation: {
        Entity: 'CurrentVer-OfficeLocations',
        File: 'docs/docs-officelocation.xml',
        ApiType: 'Lookup Methods',
    },
    DocsBinderList: {
        Entity: 'CurrentVer-BinderStatusList',
        File: 'docs/docs-binderlist.xml',
        ApiType: 'Lookup Methods',
    },
    DocsServiceType: {
        Entity: 'CurrentVer-ServiceTypes',
        File: 'docs/docs-Servicetypes.xml',
        ApiType: 'Lookup Methods',
    },
    DocsDRLCategories: {
        Entity: 'CurrentVer-DRLCategories',
        File: 'docs/docs-drlcategories.xml',
        ApiType: 'Lookup Methods',
    },
    DocsCreatenewBinder: {
        Entity: 'CurrentVer-CreateBinder',
        File: 'docs/docs-createbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsUploadBinder: {
        Entity: 'CurrentVer-UploadBinderDocuments',
        File: 'docs/docs-uploadbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsubmitBinder: {
        Entity: 'CurrentVer-BinderSubmissionComplete',
        File: 'docs/docs-submitbinder.xml',
        ApiType: 'Action Methods',
    },
    DocUpdateProject: {
        Entity: 'CurrentVer-UpdateProjectID',
        File: 'docs/docs-updateprojectid.xml',
        ApiType: 'Action Methods',
    },
    DocsGetStatus: {
        Entity: 'CurrentVer-GetStatus',
        File: 'docs/docs-getstatus.xml',
        ApiType: 'Action Methods',
    },
    DocsDocuments: {
        Entity: 'CurrentVer-GetDocuments',
        File: 'docs/docs-getdocuments.xml',
        ApiType: 'Action Methods',
    },
    DocsDownloadDocuments: {
        Entity: 'CurrentVer-DownloadDocument',
        File: 'docs/docs-downloaddoc.xml',
        ApiType: 'Action Methods',
    },
    DocsDRLOutput: {
        Entity: 'DocsDRLOutput',
        File: 'docs/docs-getdrloutput.xml',
        ApiType: 'Action Methods',
    },

    DocsChangeBinderStatus: {
        Entity: 'CurrentVer-ChangeBinderStatus',
        File: 'docs/docs-changebinderstatus.xml',
        ApiType: 'Action Methods',
    },
    DocsStatesandLocalities: {
        Entity: 'CurrentVer-GetStatesandLocalities',
        File: 'docs/docs-statesandlocalities.xml',
        ApiType: 'Action Methods',
    },
    DocsDownloadBinder: {
        Entity: 'CurrentVer-DownloadBinderPBFX',
        File: 'docs/docs-downloadbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsDownloadBinderPBFXSAML: {
        Entity: 'CurrentVer-DownloadBinderPBFXSAML',
        File: 'docs/docs-downloadbinderpbfxsaml.xml',
        ApiType: 'Action Methods',
    },
    DocsGetBinderDetails: {
        Entity: 'CurrentVer-GetBinderDetails',
        File: 'docs/docs-getbinderdetails.xml',
        ApiType: 'Action Methods',
    },
    DocsBinderStatuswithState: {
        Entity: 'CurrentVer-BinderStatuswithState',
        File: 'docs/docs-bindersstatuswithstates.xml',
        ApiType: 'Action Methods',
    },
    DocsUnClearNotes: {
        Entity: 'CurrentVer-UnclearedNotes',
        File: 'docs/docs-unclearnotes.xml',
        ApiType: 'Lists',
    },
    DocsUnReviewedTRS: {
        Entity: 'CurrentVer-UnreviewedTRStamps',
        File: 'docs/docs-unreviewedtrs.xml',
        ApiType: 'Lists',
    },
    DocsStickyNotes: {
        Entity: 'CurrentVer-GetUnreviewedStickyNotes',
        File: 'docs/docs-stickynotes.xml',
        ApiType: 'Lists',
    },
    DocsWorkPaperL1: {
        Entity: 'CurrentVer-UnreviewedWorkpapersByL1',
        File: 'docs/docs-workpapersbyL1.xml',
        ApiType: 'Lists',
    },
    DocsWorkPaperL2: {
        Entity: 'CurrentVer-UnreviewedWorkpapersByL2',
        File: 'docs/docs-workpapersbyL2.xml',
        ApiType: 'Lists',
    },
    DocsWorkPaperL3: {
        Entity: 'CurrentVer-UnreviewedWorkpapersByL3',
        File: 'docs/docs-workpapersbyL3.xml',
        ApiType: 'Lists',
    },
    DocsWorkPaperL4: {
        Entity: 'CurrentVer-UnreviewedWorkpapersByL4',
        File: 'docs/docs-workpapersbyL4.xml',
        ApiType: 'Lists',
    },
    DocsPendingReviewCount: {
        Entity: 'CurrentVer-RequestedDocsPendingReview',
        File: 'docs/docs-pendingreviewcount.xml',
        ApiType: 'Lists',
    },
    DocsPendingSignature: {
        Entity: 'CurrentVer-RequestedDocsPendingSignature',
        File: 'docs/docs-pendingsignature.xml',
        ApiType: 'Lists',
    },
    DocsPendingUpload: {
        Entity: 'CurrentVer-RequestedDocsPendingUpload',
        File: 'docs/docs-pendingupload.xml',
        ApiType: 'Lists',
    },
    DocsMiReports: {
        Entity: 'CurrentVer-MiReports',
        File: 'docs/docs-mireports.xml',
        ApiType: 'Lists',
    },
    DocsAccountUsageHistory: {
        Entity: 'CurrentVer-AccountUsageHistory',
        File: 'docs/docs-accountusagehistory.xml',
        ApiType: 'Billing',
    },
    DocsBinderAuditLog: {
        Entity: 'CurrentVer-GetBinderAuditLog',
        File: 'docs/docs-binderauditlog.xml',
        ApiType: 'Action Methods',
    },
    DocsPushEngagementStatus: {
        Entity: 'CurrentVer-PushEngagementStatus',
        File: 'docs/docs-pushengagementstatus.xml',
        ApiType: 'Notification',
    },
    DocsPushDocumentType: {
        Entity: 'CurrentVer-PushDocumentType',
        File: 'docs/docs-pushdocumenttype.xml',
        ApiType: 'Notification',
    },
    DocsDocumentsUploaded: {
        Entity: 'CurrentVer-DocumentsUploaded',
        File: 'docs/docs-documentsuploaded.xml',
        ApiType: 'Notification',
    },
    DocsDRL: {
        Entity: 'CurrentVer-DRL',
        File: 'docs/docs-drl.xml',
        ApiType: 'Notification',
    },
    DocsGetDRLOutput: {
        Entity: 'CurrentVer-GetDRLOutput',
        File: 'docs/docs-getdrloutput.xml',
        ApiType: 'Action Methods',
    },
    DocsUpdateOwnerMember: {
        Entity: 'CurrentVer-UpdateOwnerMember', 
        File: 'docs/docs-updateownermember.xml',
        ApiType: 'Action Methods',
    },
    DocsPrintBinder: {
        Entity: 'CurrentVer-PrintBinder', 
        File: 'docs/docs-printbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsCreateClient: {
        Entity: 'CurrentVer-CreateClient',
        File: 'docs/docs-createclient.xml',
        ApiType: 'TaxCaddy',
    },
    DocsGetClientDetails: {
        Entity: 'CurrentVer-GetClientDetails',
        File: 'docs/docs-getclientdetails.xml',
        ApiType: 'TaxCaddy',
    },
    DocsCreateDrl: {
        Entity: 'CurrentVer-CreateDrl',
        File: 'docs/docs-createdrl.xml',
        ApiType: 'TaxCaddy',
    },
    DocsSendDrl: {
        Entity: 'CurrentVer-SendDrl',
        File: 'docs/docs-senddrl.xml',
        ApiType: 'TaxCaddy',
    },
    DocsClientSubscribe: {
        Entity: 'CurrentVer-ClientSubscribe',
        File: 'docs/docs-clientsubscribe.xml',
        ApiType: 'TaxCaddy',
    },
    DocsClientUnsubscribe: {
        Entity: 'CurrentVer-ClientUnsubscribe',
        File: 'docs/docs-clientunsubscribe.xml',
        ApiType: 'TaxCaddy',
    },
    DocsGetDRLPDFDetails: {
        Entity: 'CurrentVer-GetDRLPDFDetails',
        File: 'docs/docs-getdrlpdfdetails.xml',
        ApiType: 'Action Methods',
    },
    DocsTaxcaddyDownloadDocument: {
        Entity: 'CurrentVer-TaxcaddyDownloadDocument',
        File: 'docs/docs-taxcaddydownloaddocument.xml',
        ApiType: 'TaxCaddy',
    },
    DocsTaxcaddyDisconnectDevices: {
        Entity: 'CurrentVer-TaxcaddyDisconnectDevices',
        File: 'docs/docs-taxcaddydisconnectdevices.xml',
        ApiType: 'TaxCaddy',
    },
    DocsGetDRLStatus: {
        Entity: 'CurrentVer-GetDRLStatus',
        File: 'docs/docs-getdrlstatus.xml',
        ApiType: 'TaxCaddy',
    },
    ApiGetToken: {
        Entity: 'ApiGetToken',
        File: 'apiproducts/api-gettoken.xml',
    },
    ApiTaxSotware: {
        Entity: 'ApiTaxSotware',
        File: 'apiproducts/api-taxsoftware.xml',
    },
    ApiBinderTypes: {
        Entity: 'ApiBinderTypes',
        File: 'apiproducts/api-bindertypes.xml',
    },
    ApiServiceTypes: {
        Entity: 'ApiServiceTypes',
        File: 'apiproducts/api-servicetypes.xml',
    },
    ApiBinderTemplates: {
        Entity: 'ApiBinderTemplates',
        File: 'apiproducts/api-bindertemplates.xml',
    },
    ApiOfficeLocations: {
        Entity: 'ApiOfficeLocations',
        File: 'apiproducts/api-officelocations.xml',
    },
    ApiBinderStatusList: {
        Entity: 'ApiBinderStatusList',
        File: 'apiproducts/api-binderstatuslist.xml',
    },
    ApiCreateBinder: {
        Entity: 'ApiCreateBinder',
        File: 'apiproducts/api-createbinder.xml',
    },
    ApiUploadBinder: {
        Entity: 'ApiUploadBinder',
        File: 'apiproducts/api-uploadbinder.xml',
    },
    ApiBinderSubmit: {
        Entity: 'ApiBinderSubmit',
        File: 'apiproducts/api-bindersubmit.xml',
    },
    ApiUploadProject: {
        Entity: 'ApiUploadProject',
        File: 'apiproducts/api-updateprojectid.xml',
    },
    ApiGetStatus: {
        Entity: 'ApiGetStatus',
        File: 'apiproducts/api-getstatus.xml',
    },
    ApiChangeBinder: {
        Entity: 'ApiChangeBinder',
        File: 'apiproducts/api-changebinderstatus.xml',
    },
    ApiGetBinderDetails: {
        Entity: 'ApiGetBinderDetails',
        File: 'apiproducts/api-getbinderdetails.xml',
    },
    ApiGetDocuments: {
        Entity: 'ApiGetDocuments',
        File: 'apiproducts/api-getdocuments.xml',
    },
    ApiDownloadDocument: {
        Entity: 'ApiDownloadDocument',
        File: 'apiproducts/api-downloaddocument.xml',
    },
    ApiGetDRLOutput: {
        Entity: 'ApiGetDRLOutput',
        File: 'apiproducts/api-drloutput.xml',
    },
    ApiUpdateProjectID: {
        Entity: 'ApiUpdateProjectID',
        File: 'apiproducts/api-updateprojectid.xml',
    },
    ApiStateandLocation: {
        Entity: 'ApiStateandLocation',
        File: 'apiproducts/api-stateandlocation.xml',
    },
    ApiDownloadBinderPBFX: {
        Entity: 'ApiDownloadBinderPBFX',
        File: 'apiproducts/api-downloadbinderpbfx.xml',
    },
    ApiGetBinderStatuswithStates: {
        Entity: 'ApiGetBinderStatuswithStates',
        File: 'apiproducts/api-getbinderstatuswithstates.xml',
    },
    ApiGetBinderAuditLog: {
        Entity: 'ApiGetBinderAuditLog',
        File: 'apiproducts/api-binderauditlog.xml',
    },
    ApiUnclearNotes: {
        Entity: 'ApiUnclearNotes',
        File: 'apiproducts/api-unclearnotes.xml',
    },
    ApiUnReviewedTRS: {
        Entity: 'ApiUnReviewedTRS',
        File: 'apiproducts/api-unreviewedtrs.xml',
    },
    ApiStickyNotes: {
        Entity: 'ApiStickyNotes',
        File: 'apiproducts/api-stickynotes.xml',
    },
    ApiWorkpapersbyL1: {
        Entity: 'ApiWorkpapersbyL1',
        File: 'apiproducts/api-workpaptersbyl1.xml',
    },
    ApiWorkpapersbyL2: {
        Entity: 'ApiWorkpapersbyL2',
        File: 'apiproducts/api-workpaptersbyl2.xml',
    },
    ApiWorkpapersbyL3: {
        Entity: 'ApiWorkpapersbyL3',
        File: 'apiproducts/api-workpaptersbyl3.xml',
    },
    ApiWorkpapersbyL4: {
        Entity: 'ApiWorkpapersbyL4',
        File: 'apiproducts/api-workpaptersbyl4.xml',
    },
    ApiPendingReview: {
        Entity: 'ApiPendingReview',
        File: 'apiproducts/api-pendingreview.xml',
    },
    ApiPendingSignature: {
        Entity: 'ApiPendingSignature',
        File: 'apiproducts/api-pendingsignature.xml',
    },
    ApiPendingUpload: {
        Entity: 'ApiPendingUpload',
        File: 'apiproducts/api-pendingupload.xml',
    },
    ApiBinderAuditlog: {
        Entity: 'ApiBinderAuditlog',
        File: 'apiproducts/api-binderauditlog.xml',
    },
    ApiBinderdetails: {
        Entity: 'ApiBinderdetails',
        File: 'apiproducts/api-binderdetails.xml',
    },
    ApiGetBinderinfo: {
        Entity: 'ApiGetBinderinfo',
        File: 'apiproducts/api-getbinderinfo.xml',
    },
    ApiGetTokenOAuth: {
        Entity: 'ApiGetTokenOAuth',
        File: 'apiproducts/api-gettokenoauth.xml',
    },
    ApiOCR: {
        Entity: 'ApiOCR',
        File: 'apiproducts/api-ocr.xml',
    },
    ApiPushEngagementStatus: {
        Entity: 'ApiPushEngagementStatus',
        File: 'apiproducts/api-pushengagementstatus.xml',
    },
    ApiPushDocumentType: {
        Entity: 'ApiPushDocumentType',
        File: 'apiproducts/api-pushdocumenttype.xml',
    },
    ApiDocumentsUploaded: {
        Entity: 'ApiDocumentsUploaded',
        File: 'apiproducts/api-documentsuploaded.xml',
    },
    ApiDRL: {
        Entity: 'ApiDRL',
        File: 'apiproducts/api-drl.xml',
    },
    ApiNewFileAvailable: {
        Entity: 'ApiNewFileAvailable',
        File: 'apiproducts/api-newfileavailablenotification.xml',
    },
    ApiAcceptedFiles: {
        Entity: 'ApiAcceptedFiles',
        File: 'apiproducts/api-fileacceptednotification.xml',
    },
    ApiDRLOutputNotification: {
        Entity: 'ApiDRLOutputNotification',
        File: 'apiproducts/api-drloutputnotification.xml',
    },
    ApiMIReport: {
        Entity: 'ApiMIReport',
        File: 'apiproducts/api-mireport.xml',
    },
    ApiDRLCategories: {
        Entity: 'ApiDRLCategories',
        File: 'apiproducts/api-drlcategories.xml',
    },
    ApiUpdateOwnerMember: {
        Entity: 'ApiUpdateOwnerMember',
        File: 'apiproducts/api-updateownermember.xml',
    },
    ApiAccountUsageHistory: {
        Entity: 'ApiAccountUsageHistory',
        File: 'apiproducts/api-accountusagehistory.xml',
    },
    ApiPrintBinder: {
        Entity: 'ApiPrintBinder',
        File: 'apiproducts/api-printbinder.xml',
    },
    ApiCreateClient: {
        Entity: 'ApiCreateClient',
        File: 'apiproducts/api-createclient.xml',
    },
    ApiGetClientDetails: {
        Entity: 'ApiGetClientDetails',
        File: 'apiproducts/api-getclientdetails.xml',
    },
    ApiCreateDrl: {
        Entity: 'ApiCreateDrl',
        File: 'apiproducts/api-createdrl.xml',
    },
    ApiSendDrl: {
        Entity: 'ApiSendDrl',
        File: 'apiproducts/api-senddrl.xml',
    },
    ApiClientSubscribe: {
        Entity: 'ApiClientSubscribe',
        File: 'apiproducts/api-clientsubscribe.xml',
    },
    ApiClientUnsubscribe: {
        Entity: 'ApiClientUnsubscribe',
        File: 'apiproducts/api-clientunsubscribe.xml',
    },
    ApiGetDRLPDFDetails: {
        Entity: 'ApiGetDRLPDFDetails',
        File: 'apiproducts/api-getdrlpdfdetails.xml',
    },
    ApiTaxcaddyDownloadDocument: {
        Entity: 'ApiTaxcaddyDownloadDocument',
        File: 'apiproducts/api-taxcaddydownloaddocument.xml',
    },
    ApiTaxcaddyDisconnectDevices: {
        Entity: 'ApiTaxcaddyDisconnectDevices',
        File: 'apiproducts/api-taxcaddydisconnectdevices.xml',
    },
        ApiGetDRLStatus: {
        Entity: 'ApiGetDRLStatus',
        File: 'apiproducts/api-getdrlstatus.xml',
    },
    
    DownloadScripts: {
        Entity: 'DownloadScripts',
        File: 'download/scripts.xml',
    },
    DocsGetBinderInfo: {
        Entity: 'CurrentVer-GetBinderPendingItems',
        File: 'docs/docs-getbinderinfo.xml',
        ApiType: 'Action Methods',
    },
    DownloadSdk: {
        Entity: 'DownloadSdk',
        File: 'download/sdk.xml',
    },
    DownloadDocs: {
        Entity: 'DownloadDocs',
        File: 'download/documents.xml',
    },
    DocsVer4gettoken: {
        Entity: 'Version4-GetToken',
        File: 'docs/version4.0/docs-gettoken.xml',
        ApiType: 'Authentication',
    },
    DocsVer4TaxSoftware: {
        Entity: 'Version4-TaxSoftware',
        File: 'docs/version4.0/docs-taxsoftware.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4BinderTypes: {
        Entity: 'Version4-BinderTypes',
        File: 'docs/version4.0/docs-bindertypes.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4ServiceTypes: {
        Entity: 'Version4-ServiceTypes',
        File: 'docs/version4.0/docs-servicetypes.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4BinderTemplates: {
        Entity: 'Version4-BinderTemplates',
        File: 'docs/version4.0/docs-bindertemplates.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4OfficeLocations: {
        Entity: 'Version4-OfficeLocations',
        File: 'docs/version4.0/docs-officelocations.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4BinderStatusList: {
        Entity: 'Version4-BinderStatusList',
        File: 'docs/version4.0/docs-binderstatuslist.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4CreateNewBinder: {
        Entity: 'Version4-CreateBinder',
        File: 'docs/version4.0/docs-createbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4DRLCategories: {
        Entity: 'Version4-DRLCategories',
        File: 'docs/version4.0/docs-drlcategories.xml',
        ApiType: 'Lookup Methods',
    },
    DocsVer4UploadBinderDocuments: {
        Entity: 'Version4-UploadBinderDocuments',
        File: 'docs/version4.0/docs-uploadbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4BinderSubmissionComplete: {
        Entity: 'Version4-BinderSubmissionComplete',
        File: 'docs/version4.0/docs-bindersubmit.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4UpdateProjectID: {
        Entity: 'Version4-UpdateProjectID',
        File: 'docs/version4.0/docs-uploadprojectid.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetStatus: {
        Entity: 'Version4-GetStatus',
        File: 'docs/version4.0/docs-getstatus.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetDocuments: {
        Entity: 'Version4-GetDocuments',
        File: 'docs/version4.0/docs-getdocuments.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4DownloadDocument: {
        Entity: 'Version4-DownloadDocument',
        File: 'docs/version4.0/docs-downloaddocument.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4ChangeBinderStatus: {
        Entity: 'Version4-ChangeBinderStatus',
        File: 'docs/version4.0/docs-changebinderstatus.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetStatesandLocalities: {
        Entity: 'Version4-GetStatesandLocalities',
        File: 'docs/version4.0/docs-statesandlocalities.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4DownloadBinderPBFX: {
        Entity: 'Version4-DownloadBinderPBFX',
        File: 'docs/version4.0/docs-downloadbinder.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetBinderDetails: {
        Entity: 'Version4-GetBinderDetails',
        File: 'docs/version4.0/docs-getbinderdetails.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4BinderStatuswithState: {
        Entity: 'Version4-BinderStatuswithState',
        File: 'docs/docs-bindersstatuswithstates.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4UnclearedNotes: {
        Entity: 'Version4-UnclearedNotes',
        File: 'docs/version4.0/docs-unclearnotes.xml',
        ApiType: 'Lists',
    },
    DocsVer4UnreviewedTRStamps: {
        Entity: 'Version4-UnreviewedTRStamps',
        File: 'docs/version4.0/docs-unreviewedtrs.xml',
        ApiType: 'Lists',
    },
    DocsVer4GetUnreviewedStickyNotes: {
        Entity: 'Version4-GetUnreviewedStickyNotes',
        File: 'docs/version4.0/docs-stickynotes.xml',
        ApiType: 'Lists',
    },
    DocsVer4UnreviewedWorkpapersByL1: {
        Entity: 'Version4-UnreviewedWorkpapersByL1',
        File: 'docs/version4.0/docs-workpaptersbyl1.xml',
        ApiType: 'Lists',
    },
    DocsVer4UnreviewedWorkpapersByL2: {
        Entity: 'Version4-UnreviewedWorkpapersByL2',
        File: 'docs/version4.0/docs-workpaptersbyl2.xml',
        ApiType: 'Lists',
    },
    DocsVer4UnreviewedWorkpapersByL3: {
        Entity: 'Version4-UnreviewedWorkpapersByL3',
        File: 'docs/version4.0/docs-workpaptersbyl3.xml',
        ApiType: 'Lists',
    },
    DocsVer4UnreviewedWorkpapersByL4: {
        Entity: 'Version4-UnreviewedWorkpapersByL4',
        File: 'docs/version4.0/docs-workpaptersbyl4.xml',
        ApiType: 'Lists',
    },
    DocsVer4RequestedDocsPendingReview: {
        Entity: 'Version4-RequestedDocsPendingReview',
        File: 'docs/version4.0/docs-pendingreview.xml',
        ApiType: 'Lists',
    },
    DocsVer4RequestedDocsPendingSignature: {
        Entity: 'Version4-RequestedDocsPendingSignature',
        File: 'docs/version4.0/docs-pendingsignature.xml',
        ApiType: 'Lists',
    },
    DocsVer4RequestedDocsPendingUpload: {
        Entity: 'Version4-RequestedDocsPendingUpload',
        File: 'docs/version4.0/docs-pendingupload.xml',
        ApiType: 'Lists',
    },
    DocsVer4GetBinderPendingItems: {
        Entity: 'Version4-GetBinderPendingItems',
        File: 'docs/version4.0/docs-getbinderinfo.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetBinderAuditLog: {
        Entity: 'Version4-GetBinderAuditLog',
        File: 'docs/version4.0/docs-binderauditlog.xml',
        ApiType: 'Action Methods',
    },
    DocsVer4GetDRLOutput: {
        Entity: 'Version4-GetDRLOutput',
        File: 'docs/version4.0/docs-getdrloutput.xml',
        ApiType: 'Action Methods',
    },
};
export default CMS;
